const ProfileCircle = ({ height = "43" }) => {
  return (
    <svg
      height={height}
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.9283 22.7411C21.8052 22.7235 21.6469 22.7235 21.5061 22.7411C18.4101 22.6356 15.9473 20.1024 15.9473 16.9887C15.9473 13.8047 18.5156 11.2188 21.7172 11.2188C24.9013 11.2188 27.4872 13.8047 27.4872 16.9887C27.4696 20.1024 25.0244 22.6356 21.9283 22.7411Z"
        stroke="#A9AEB4"
        strokeWidth="2.11097"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.5726 34.3514C30.4413 37.2188 26.2897 38.9604 21.716 38.9604C17.1422 38.9604 12.9906 37.2188 9.85938 34.3514C10.0353 32.6978 11.0908 31.0794 12.9731 29.8128C17.7931 26.6112 25.674 26.6112 30.4589 29.8128C32.3412 31.0794 33.3966 32.6978 33.5726 34.3514Z"
        stroke="#A9AEB4"
        strokeWidth="2.11097"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.7164 38.9604C31.4318 38.9604 39.3078 31.0844 39.3078 21.369C39.3078 11.6535 31.4318 3.77759 21.7164 3.77759C12.0009 3.77759 4.125 11.6535 4.125 21.369C4.125 31.0844 12.0009 38.9604 21.7164 38.9604Z"
        stroke="#A9AEB4"
        strokeWidth="2.11097"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ProfileCircle;
